import {BaseModel} from '../../common/base/model';

export class TransferModel extends BaseModel {
  constructor(data) {
    super(data, {
      type: 'ownAccount',
      ownAccountInfo: false,
      giftInfo: false,
      inheritanceInfo: false,
      otherInfo: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/transfer/transfer.model.js